const GraphqlData = window.GraphqlData;

export const SpecialOffers = {
  props: ["manufacturer", "allBrands", "lang", "graphqlEndpoint"],
  data() {
    return {
      offers: null,
      modalVisible: false,
      makes: [],
    };
  },
  created() {
  },
  mounted() {
    GraphqlData.authenticateAndFetchData(null,'special-offers', null, null, this.graphqlEndpoint)
      .then((result) => {
        this.offers = result;
        let offersMakes = '';
        
        // Filter by manufacturer and other brands
        if(this.allBrands !== '')
          offersMakes = this.manufacturer.toLowerCase() + ',' + this.allBrands.toLowerCase();
        else
          offersMakes = this.manufacturer.toLowerCase();

        const filteredData = this.offers.filter(item => offersMakes.includes(item.offers.make.toLowerCase()));

        // Get unique makes from the offers
        this.makes = [...new Set(filteredData.map(item => item.offers.make))];
        this.offers = filteredData;

        // Order filtered data by make
        this.offers.sort((a, b) => (a.offers.make > b.offers.make) ? 1 : -1);
  
        // Filter by start date with format DD/MM/YYYY
        const today = new Date();
  
        const filteredDataByDateStart = this.offers.filter((item) => {
          if(item.offers.startDate == null)
            return true;
            
            // Convertir item.offers.startDate a un objeto de fecha
            const startDate = new Date(item.offers.startDate.split('/').reverse().join('-'));
            // Comparar las fechas
            return startDate <= today;
          
        });

        this.offers = filteredDataByDateStart;
  
        // Filter by end date with format DD/MM/YYYY
        const filteredDataByDate = this.offers.filter((item) => {
          if(item.offers.endDate == null)
            return true;
          
            // Convertir item.offers.endDate a un objeto de fecha
            const endDate = new Date(item.offers.endDate.split('/').reverse().join('-'));
            // Comparar las fechas
            return endDate >= today;
          
        });
  
        this.offers = filteredDataByDate;
  
      })
      .catch((error) => {
        console.error("Error:", error.message);
      });
  },
  methods: {
    show(make) {
      
      jQuery('.offers-brands span.offer-brand-item').each(function () {
        jQuery(this).removeClass(`offer-selected`);  
      });

      jQuery(`.${make.toLowerCase()}-offers`).addClass(`offer-selected`);  

      if(make && make !== 'all'){
        // Show all elements with class make-offer and hide others
        jQuery('.offer-cards div.offers').each(function(){
          // Show all elements with class make-offer
          if(jQuery(this).hasClass(`${make.toLowerCase()}-offer`)){
            jQuery(this).show();
          }
          else{
            jQuery(this).hide();
          }
        });
      }else{
        // Show all elements with class make-offer
        jQuery('.offer-cards div.offers').each(function(){
          jQuery(this).show();
        });
      }
    },
    hideModal(){
      jQuery('body').removeClass('overflow-hidden');
      this.modalVisible = false;
    },
    showItemInfo(item){
      if(item){
        let formattedLegalEn ='';
        let formattedLegalFr ='';

        if(item.legalEn)
          formattedLegalEn = item.legalEn.replace(/\r\n|\n/g, '<br>');
        
        if(item.legalFr)
          formattedLegalFr = item.legalFr.replace(/\r\n|\n/g, '<br>');

        
        setTimeout(() => {
          jQuery('body').addClass('overflow-hidden');
          jQuery('.lbx-bap-detail-modal__content').html(`
            <div class="flex flex-row flex-wrap justify-center lbx-bap-detail-modal__content__section">
              ${(!item.leaseApr && item.leaseLabel) || item.leaseApr ? `<h4 class="font-primary-bold flex text-center xl:text-left items-center justify-center w-full xl:w-1/3 lbx-bap-detail-modal__content_lease">${item.leaseApr ? item.leaseApr : 0}<span class="text-sm font-primary lbx-bap-detail-modal__content_lease-span">%</span> &nbsp;${(item.leaseDisclaimer ? item.leaseDisclaimer : '')}</h4>` : ''}
              ${item.downPayment ? `<h4 class="font-primary-bold flex text-center xl:text-left items-center justify-center w-full xl:w-1/3 lbx-bap-detail-modal__content_downpayment">${item.downPayment} ${item.downPaymentLabel}</h4>` : ''}
              ${item.payment ? `<h4 class="font-primary-bold flex text-center xl:text-left items-center justify-center w-full xl:w-1/3 lbx-bap-detail-modal__content_payment">$${item.payment} ${(item.paymentDisclaimer ? item.paymentDisclaimer : '')}</h4>` : ''} 
            </div>
            <div class="flex flex-row gap-4 max-h-52 overflow-auto mt-2 lbx-bap-detail-modal__content_legal-section">
              <div class="w-full text-xs lbx-bap-detail-modal__content_legal-value">
              ${this.lang == "en-CA" ? formattedLegalEn : formattedLegalFr}</div>
            </div>`
          );
        }, 10);
        
        this.modalVisible = true;
      }
    },
    loadingTemplate() {
      return `
      <div role="status" class="flex items-center justify-center">
        <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path class="text-primary fill-current"
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="none" />
        </svg>
      </div>
      <span class="flex items-center font-primary-bold justify-center loading-text">${
        this.lang == "en-CA" ? "Loading" : "Chargement"
      }...</span>`;
    },
  },
};